import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaShieldAlt, FaBolt, FaHeadset, FaUndo } from 'react-icons/fa'

// Marketplace trust strip — neutral, dependency-light.
// Rendered between hero and category strip.
//
// No props; pure presentation. Labels are i18n keys (resolved in render).

const ITEMS = [
  {
    icon: <FaShieldAlt />,
    titleKey: 'trustbar.secureTitle',
    textKey:  'trustbar.secureText',
    tone:  'text-success-600 bg-success-50',
  },
  {
    icon: <FaBolt />,
    titleKey: 'trustbar.fastTitle',
    textKey:  'trustbar.fastText',
    tone:  'text-accent-600 bg-accent-50',
  },
  {
    icon: <FaHeadset />,
    titleKey: 'trustbar.supportTitle',
    textKey:  'trustbar.supportText',
    tone:  'text-brand-600 bg-brand-50',
  },
  {
    icon: <FaUndo />,
    titleKey: 'trustbar.refundTitle',
    textKey:  'trustbar.refundText',
    tone:  'text-warning-600 bg-warning-50',
  },
]

const TrustBar = () => {
  const { t } = useTranslation()
  return (
  <section className='w-full max-w-marketplace mx-auto px-4 sm:px-5 md:px-6 lg:px-8 mt-3 mb-0'>
    <div className='rounded-card border border-slate-200 bg-white shadow-card'>
      <ul className='grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 divide-x divide-slate-100 md:divide-x-0 md:divide-y'>
        {ITEMS.map((it, i) => (
          <li key={i} className='flex items-center gap-3 p-4 transition-colors hover:bg-slate-50/70'>
            <span className={`shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-card ${it.tone} transition-transform hover:scale-105`}>
              {it.icon}
            </span>
            <div className='min-w-0'>
              <p className='text-sm font-semibold text-slate-800 truncate'>{t(it.titleKey)}</p>
              <p className='text-xs text-slate-500 truncate'>{t(it.textKey)}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
  )
}

export default TrustBar
